import { get as getFromPdo, } from 'application/pageDataObject';
import { getRandomElement, } from 'utils/array';
import safeLocalStorageProvider from 'providers/safeLocalStorageProvider';


const NO_MESSAGE_IN_LOCAL_STORAGE = null;
const FB_BOT_MSG_KEY = 'NM_FB_BOT_MSG_KEY';
const messengerBotDisplayMessages = [
  'Get the latest football news',
  'Get the latest breaking news',
  'Never miss a breaking story',
];


function getDisplayMessage(){
  const cachedMessage = safeLocalStorageProvider.get(FB_BOT_MSG_KEY,
    NO_MESSAGE_IN_LOCAL_STORAGE);
  if (cachedMessage !== NO_MESSAGE_IN_LOCAL_STORAGE) {
    return cachedMessage;
  }
  const selectedMsg = getRandomElement(messengerBotDisplayMessages);
  safeLocalStorageProvider.set(FB_BOT_MSG_KEY, selectedMsg);
  return selectedMsg;
}

const DEFAULT_STATE = {
  displayMessage: getDisplayMessage(),
  appId: getFromPdo('config.facebook.app_id'),
  pageId: getFromPdo('config.facebook.page_id'),
};

export function facebookBotReducer(state = DEFAULT_STATE, action){
  return state;
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/facebook_bot/facebookBotReducer.js